import type { ComponentType, RefObject } from "react";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import type { SvgIconProps, SxProps } from "@mui/material";
import Icon from "@mui/material/Icon";
import type { Theme } from "@mui/material/styles"; // import { useMissingDataType } from "src/business-hooks/useMissingDataType";
import type { MetricGroupTypeName } from "src/business-utils/metrics/metricTypes";
import {
  DistributionIcon,
  EnvIcon,
  FreshnessIcon,
  OtherMetricTypeIcon,
  ResourcesIcon,
  SchemaIcon,
  SLAIcon,
  TimeIcon,
  VolumeIcon,
} from "@ui-icons";

// import { useMissingDataType } from "src/business-hooks/useMissingDataType";

const ICON_SIZE = "16px";

// Annotated, not inferred: a metric_group_type added to metric_types.csv with no icon here
// falls through to MUI's empty `Icon`. The Record half makes that a type error; the index
// half keeps the extra non-CSV keys below legal.
const IconByType: Record<MetricGroupTypeName, ComponentType<SvgIconProps>> &
  Record<string, ComponentType<SvgIconProps>> = {
  environment: EnvIcon,
  // No dedicated streaming icon yet; the neutral one beats MUI's empty `Icon` fallback.
  streaming: OtherMetricTypeIcon,
  time: HourglassBottomIcon,
  volume: VolumeIcon,
  schema: SchemaIcon,
  distribution: DistributionIcon,
  resources: ResourcesIcon,
  freshness: FreshnessIcon,
  sla: SLAIcon,
  duration: TimeIcon,
  others: OtherMetricTypeIcon,
};

export const MetricGroupIcon = ({
  type,
  iconSX,
  ref,
}: SvgIconProps & {
  type: MetricGroupTypeName;
  iconSX?: SxProps<Theme>;
}) => {
  // todo remove || Icon
  const MetricGroupIcon =
    IconByType[type?.toLowerCase() as MetricGroupTypeName] || Icon;

  return (
    // todo wrap with <Icon>
    <MetricGroupIcon
      ref={ref}
      sx={{
        color: ({ palette }) => palette.primary.main,
        fontSize: ICON_SIZE,
        ...iconSX,
      }}
    />
  );
};

export const MetricGroupTypeWithIcon = ({
  type,
  iconSX,
  ref,
  ...props
}: {
  type: MetricGroupTypeName;
  iconSX?: SxProps<Theme>;
  ref?: RefObject<HTMLDivElement>;
  props: SvgIconProps;
}) => {
  // I DO NOT SEE A NEED FOR THE BELOW:
  // const valid = isValidType(type);

  // useMissingDataType(
  //   "badMetricGroupType",
  //   type,
  //   `Metric group type: ${type} is not supported`,
  //   !valid
  // );

  return (
    <div ref={ref} {...props} className="inline-flex gap-2 items-center min-w-0">
      <MetricGroupIcon type={type} iconSX={iconSX} />
      <span className="truncate" style={{ fontSize: "1em" }}>
        {type}
      </span>
    </div>
  );
};
